import script from "./FinancePortDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancePortDetails.vue?vue&type=script&setup=true&lang=js"

import "./FinancePortDetails.vue?vue&type=style&index=0&id=125033c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125033c9"]])

export default __exports__